import type { Kind } from '../../../shared/protocol';

// 영상·송출 연결의 "원하는 상태". 컨트롤러(2-controllers/meeting/links.ts)가 0.25초마다 정해 두면,
// 1-endpoints/media/meeting/sync.ts가 프레임마다 꺼내 AV·Sfu에 맞춘다(컨트롤러는 영상·송출 객체를 직접 부르지 않는다).
export type SfuWant = { on: false } | { on: true; may: Kind[]; recv: { id: string; kind: Kind; name: string }[] };
export const WANT: { peers: string[] | null; sfu: SfuWant | null } = { peers: null, sfu: null };
export function wantMedia(peers: string[], sfu: SfuWant) { WANT.peers = peers; WANT.sfu = sfu; }
// 지금 이어지는 모임 키(shared/world/links.ts)와 그 안의 사람 수: 도구 막대가 읽는다
export const GROUP: { key: string | null; n: number } = { key: null, n: 0 };
export function setGroup(key: string | null, n: number) { GROUP.key = key; GROUP.n = n; }
